import React, {
    PropTypes,
} from 'react';
import {Table, Glyphicon} from 'react-bootstrap';
import {MenuItem} from './';
import {Dialog} from '../../components';

function renderSaleTime(saleTimeName, menu) {
    let show = false;
    const res = (
        <div>
            <div className="row" style={{
                background: "#e2e2e2",
            }}><h4 className="col-sm-4" style={{
                fontWeight: "bold",
            }}>{saleTimeName}</h4>
                <h4 className="col-sm-4">{menu.locationName}</h4></div>
            <Table condensed hover className="mb0 my-table">
                <thead>
                <tr>
                    <th>Блюдо</th>
                    <th className="hidden-xs hidden-sm text-right"><Glyphicon glyph="scale"/></th>
                    <th className="hidden-xs text-right">₴</th>
                    <th className="text-center"><img src="/images/quantity.png" role="presentation" width={17}/></th>
                    <th className="hidden-xs text-right">Итого</th>
                </tr>
                </thead>
                <tbody>
                {menu.wares.map(ware => {
                        if (ware.waresQuantity) {
                            show = true;
                            return <MenuItem {...ware} />
                        } else return null;
                    }
                )}
                </tbody>
            </Table>
        </div>
    );
    return show ? res : '';
}

function getDateString(date) {
    const dt = (('0' + date.getDate()).slice(-2));
    const month = (('0' + (date.getMonth() + 1)).slice(-2));
    const days = ['неділя', 'понеділок', 'вівторок', 'середу', 'четвер', 'п\'ятницю', 'суботу'];


    return days[date.getDay()] + ', ' + dt + '.' + month + '.' + date.getFullYear();
}

function calculateTotalCost(menu) {
    return menu.wares.reduce((res, ware) => {
            return res + ware.cost * ware.waresQuantity;
        }, 0.0
    )
}

const MenuConfirm = ({saleTimes, yes, no, show, menus, date, description}) => {
    let ordered = false;
    let totalCost = 0.0;
    const sales = saleTimes.map(saleTime => {
        const menu = menus[saleTime.saleTimeId][saleTime.orderLocation];
        const renderedSaleTime = renderSaleTime(saleTime.saleTimeName, menu);
        ordered = ordered || renderedSaleTime;
        totalCost += calculateTotalCost(menu);

        return renderedSaleTime;
    });
    const title = "Подтверждение заказа на " + getDateString(date);
    const body = <div>
        {ordered ? sales : <h4>Вы нічого не обрали!</h4>}
        {ordered && description !== '' ? <div><strong>Примітки до замовлення</strong>: {description}</div> : ''}
        {ordered ? <div><strong>Загальна сума замовлення</strong>: {totalCost.toFixed(2)} грн.</div> : ''}
    </div>;
    return <Dialog
        body={body}
        title={title}
        yesTitle={ordered ? "Підтвердити" : null}
        noTitle="Виправити"
        yes={yes}
        no={no}
        show={show}
    />;
};

MenuConfirm.propTypes = {
    saleTimes: PropTypes.array.isRequired,
    menus: PropTypes.object.isRequired,
    yes: PropTypes.func.isRequired,
    no: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    date: PropTypes.object.isRequired,
    description: PropTypes.string.isRequired,
};

export default MenuConfirm;



/** WEBPACK FOOTER **
 ** ./src/modules/food/MenuConfirm.js
 **/